<script>
  import {onMount, createEventDispatcher} from 'svelte';
  import GoogleAccount from './components/GoogleAccount.svelte';
  import {subscribeUserStatus} from '@/modules/register/streams';
  import Activity from '@/modules/register/componets/Activity.svelte';
  import Header from '@/modules/header/Header.svelte';
  import UserView2 from '../userView/UserView2.svelte';
  import lang from './BindGoogleAccount.lang';
  import LeftBanner from '@/modules/login/componets/left-banner/LeftBanner.svelte';

  export let LG = null;
  export let verificationData = null;
  export let oauthData = null;

  const dispatch = createEventDispatcher();

  let registerUIVersion = 0;

  onMount(() => {
    registerUIVersion = 1;
    subscribeUserStatus();
  });

  function handleClickBack() {
    dispatch('close');
  }
</script>

<style>
  .warp {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: #fff;
  }
  .activity-container {
    height: 100%;
    background: #000;
  }
  .back {
    width: 420px;
  }
  @media screen and (max-width: 640px) {
    .back {
      padding-top: 10px;
      padding-left: 20px;
      width: auto;
    }
    .right {
      align-items: normal;
    }
  }
</style>

<div class="warp">
  <Header isLogin={true} />
  {#if registerUIVersion === 1}
    <UserView2>
      <div class="activity-container df jcc xs:dn" slot="left">
        <LeftBanner />
      </div>
      <div class="right df fdc aic jcc" slot="right">
        <div class="back f14 lh18 cp T3" on:click={handleClickBack}>
          <i class="iconfont arrow pa backLeft">&#xe60b;</i>
          <span class="backSpan">{LG(lang.Back)}</span>
        </div>
        <GoogleAccount {LG} {verificationData} {oauthData} />
      </div>
    </UserView2>
  {/if}
</div>
